<template>
  <div>
    <loader v-if="loading" :loading="loading"></loader>
    <div class="designer-content">
      <span v-html="this.iframeUrl"></span>
    </div>
  </div>
</template>

<script>
import BaseModal from "../Base";

// TODO loader

export default {
  extends: BaseModal,
  mounted() {
    this.loading = true;

    setTimeout(() => (this.loading = false), 7000);

    // Populate some data for intercom
    if (window.novaSettings) {
      this.iframeUrl = window.novaSettings.contactFromIframe;
    }
  },
  data() {
    return {
      loading: false,
      iframeUrl: "",
    };
  },
};
</script>

